<div id="layout-wrapper">
  <app-sidebar-horizontal *ngIf="isMenuVisible"></app-sidebar-horizontal>

  <div class="main-content mt-n5">
    <div class="page-content mx-5">
      <router-outlet></router-outlet>
    </div>
  </div>

  <app-footer></app-footer>
</div>
